import { useNavigate } from "react-router-dom";
import Button from "../components/Button";
import PricingCard from "../pages/buy notes/Prising";

const featureHighlights = [
  {
    title: "Exam-Ready Notes",
    description:
      "Exam-ready handwritten notes tailored to the SPPU syllabus, with clear explanations, diagrams, and quick recaps.",
    image: "src_lib1.jpg",
    accent: "from-pink-400 via-purple-400 to-blue-400",
    stat: "180+ topic packs",
  },
  {
    title: "Previous Year Papers",
    description:
      "Solved PYQs with marking schemes so you can recognise patterns, practice confidently, and maximise scores.",
    image: "src_lib2.jpg",
    accent: "from-blue-400 via-pink-400 to-purple-400",
    stat: "1k+ solved questions",
  },
];

const learningPath = [
  {
    title: "Search by branch & unit",
    detail:
      "Use ReferMe’s smart filters to instantly locate notes and PYQs mapped to your exact syllabus coverage.",
    icon: "🔍",
  },
  {
    title: "High-Quality Study Material",
    detail:
      "Access well-structured notes and solved papers inside ReferMe for fast, efficient revision.",
    icon: "📄",
  },
  {
    title: "Revise with confidence",
    detail:
      "Highlight important concepts, revisit saved resources, and walk into exams knowing you’ve covered what matters.",
    icon: "✅",
  },
];

const Home = () => {
  const navigate = useNavigate();

  return (
    <main className="relative w-full text-white">
<div className="pointer-events-none absolute inset-0">
        <div className="absolute top-[-12%] left-[-18%] h-[620px] w-[620px] opacity-30 animate-spin-slow">
          <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <radialGradient id="heroGradient1" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#f472b6" />
                <stop offset="100%" stopColor="#60a5fa" />
              </radialGradient>
            </defs>
            <circle cx="300" cy="300" r="300" fill="url(#heroGradient1)" />
          </svg>
        </div>
        <div className="absolute bottom-[-20%] right-[-12%] h-[420px] w-[420px] opacity-30 animate-spin-slow-reverse">
          <svg viewBox="0 0 400 400" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <radialGradient id="heroGradient2" cx="50%" cy="50%" r="50%">
                <stop offset="0%" stopColor="#f472b6" />
                <stop offset="100%" stopColor="#60a5fa" />
              </radialGradient>
            </defs>
            <circle cx="200" cy="200" r="200" fill="url(#heroGradient2)" />
          </svg>
        </div>
      </div>

      <section className="relative min-h-[90vh] w-full flex items-center">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col-reverse items-center gap-16 px-5 py-16 md:flex-row md:gap-20 md:px-12 lg:px-16">
          <div className="w-full max-w-xl text-center md:text-left">
            <p className="inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/10 px-4 py-2 text-sm font-semibold text-white/80 shadow-lg backdrop-blur">
              <span className="text-lg">✨</span>
              Stop Searching, Start Scoring!
            </p>
            <h1 className="mt-6 text-4xl font-extrabold leading-tight text-white sm:text-5xl md:text-6xl">
              Your Academic Success Partner
            </h1>
            <p className="mt-4 text-base text-white/90 sm:text-lg">
              Discover premium handwritten notes and previous year question papers curated to match your syllabus. Skip the scramble — stay exam-ready with one trusted companion.
            </p>
            <div className="mt-8 flex flex-col items-center gap-4 sm:flex-row sm:items-stretch sm:justify-start">
              <Button
                className="w-full rounded-2xl bg-gradient-to-r from-purple-500 to-blue-500 px-8 py-3 text-base font-semibold text-white shadow-xl transition-all duration-300 hover:scale-105 hover:from-blue-500 hover:to-purple-500 sm:w-auto"
                onClick={() => navigate("/Search")}
              >
                Get Notes
              </Button>
              <Button
                className="w-full rounded-2xl border border-white/30 bg-white/10 px-8 py-3 text-base font-semibold text-white/90 shadow-xl backdrop-blur transition-all duration-300 hover:border-white/60 hover:bg-white/20 sm:w-auto"
                onClick={() => {
                  const url = 'https://chat.whatsapp.com/C1xnYa4xE2Y8zp0fg3TAnE';
                  const w = window.open(url, '_blank');
                  if (w) w.opener = null;
                }}
              >
                Join the Community
              </Button>
            </div>
            <p className="mt-8 text-sm uppercase tracking-[0.3em] text-white/50">
              Notes • Previous Year Papers • Exam Prep
            </p>
          </div>

          <div className="flex w-full max-w-md items-center justify-center md:max-w-lg">
            <div className="group relative w-full">
              <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-r from-purple-500 via-pink-400 to-blue-500 opacity-60 blur-3xl transition-opacity duration-500 group-hover:opacity-80" />
              <div className="relative overflow-hidden rounded-[2.5rem] border-4 border-white/40 bg-white/30 shadow-2xl backdrop-blur-sm">
                <img
                  src="mainimg.png"
                  alt="Engineering students using ReferMe to study with curated notes and PYQ papers for exam preparation"
                  className="h-full w-full object-cover"
                />
                {/* overlay text removed as requested */}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative w-full py-20">
        <div className="pointer-events-none absolute inset-0">
          <div className="absolute -top-16 right-24 h-64 w-64 rounded-full bg-gradient-to-br from-purple-400 via-pink-400 to-blue-400 opacity-20 blur-3xl" />
          <div className="absolute -bottom-24 left-12 h-72 w-72 rounded-full bg-gradient-to-tr from-blue-400 via-purple-400 to-pink-400 opacity-20 blur-3xl" />
        </div>
        <div className="relative z-10 mx-auto max-w-7xl px-5 md:px-12 lg:px-16">
          <div className="mx-auto max-w-2xl text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-white/60">
              RESOURCE LIBRARY
            </p>
            <h2 className="mt-4 text-3xl font-bold sm:text-4xl">
              Your Shortcut To Reliable Notes and PYQs
            </h2>
            <p className="mt-3 text-base text-white/70 sm:text-lg">
              Browse expertly organised resources that match your syllabus and semester timelines. Everything stays fresh with continuous student and mentor contributions.
            </p>
          </div>

          <div className="mt-14 grid gap-8 sm:grid-cols-2">
            {featureHighlights.map((feature) => (
              <article
                key={feature.title}
                className="group relative overflow-hidden rounded-3xl border border-white/15 bg-white/8 shadow-2xl backdrop-blur-lg transition-transform duration-300 hover:-translate-y-1 hover:border-white/30"
              >
                <div
                  className={`absolute -left-24 top-1/2 h-48 w-48 -translate-y-1/2 rotate-12 rounded-full bg-gradient-to-r opacity-20 blur-3xl transition-opacity duration-300 group-hover:opacity-40 ${feature.accent}`}
                />
                <div className="flex flex-col md:flex-row">
                  <div className="relative md:w-1/2 bg-white">
                    <img
                      src={feature.image}
                      alt={`${feature.title} - ${feature.description.substring(0, 80)}`}
                      className="h-48 w-full object-cover md:h-full"
                    />
                  </div>
                  <div className="flex flex-1 flex-col justify-between p-7">
                    <div>
                      <h3 className={`text-2xl font-semibold text-transparent bg-clip-text bg-gradient-to-r ${feature.accent}`}>
                        {feature.title}
                      </h3>
                      <p className="mt-3 text-sm text-white/75 sm:text-base">
                        {feature.description}
                      </p>
                    </div>
                    <div className="mt-6 flex items-center justify-between text-sm font-semibold text-white/80">
                      <span>{feature.stat}</span>
                      <button
                        onClick={() => navigate("/Search")}
                        className="rounded-full border border-white/20 px-4 py-2 text-xs uppercase tracking-widest text-white/70 transition-all duration-200 hover:border-white/40 hover:text-white"
                      >
                        Browse
                      </button>
                    </div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing section */}
      <section className="relative w-full py-12">
        <div className="relative z-10 mx-auto max-w-6xl px-5 md:px-12 lg:px-16">
          <div className="mx-auto max-w-2xl text-center mb-8">
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-white/60">PRICING</p>
            <h2 className="mt-4 text-3xl font-bold sm:text-4xl">Simple pricing that students love</h2>
            <p className="mt-3 text-base text-white/70 sm:text-lg">Choose a pre-made combo or build your own package — pricing and checkout are quick and transparent.</p>
          </div>

          <PricingCard />
        </div>
      </section>

      <section className="relative w-full py-20">
        <div className="relative z-10 mx-auto max-w-6xl px-5 md:px-12 lg:px-16">
          <div className="flex flex-col items-center text-center">
            <p className="text-sm font-semibold uppercase tracking-[0.3em] text-white/60">
              HOW IT WORKS
            </p>
            <h2 className="mt-4 text-3xl font-bold sm:text-4xl">
              Find the exact note or PYQ you need in three steps
            </h2>
            <p className="mt-3 max-w-2xl text-base text-white/70 sm:text-lg">
              ReferMe removes the friction between you and the right study material. Here’s how students move from confusion to clarity with our curated workflow.
            </p>
          </div>

          <div className="mt-12 grid gap-6 md:grid-cols-3">
            {learningPath.map((step, index) => (
              <div
                key={step.title}
                className="relative overflow-hidden rounded-3xl border border-white/15 bg-white/8 p-8 text-left shadow-xl backdrop-blur-lg transition-transform duration-300 hover:-translate-y-1"
              >
                <div className="absolute -top-20 right-0 h-40 w-40 rounded-full bg-indigo-500/10 blur-3xl" />
                <div className="relative z-10">
                  <div className="flex items-center justify-between">
                    <span className="text-4xl">{step.icon}</span>
                    <span className="text-sm font-semibold uppercase tracking-widest text-white/40">
                      Step {index + 1}
                    </span>
                  </div>
                  <h3 className="mt-4 text-xl font-semibold text-white">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-sm text-white/70">
                    {step.detail}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      
    </main>
  );
};

export default Home;
